/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowTemplateStepsControllerRemoveMutationResponse, WorkflowTemplateStepsControllerRemovePathParams, WorkflowTemplateStepsControllerRemove401, WorkflowTemplateStepsControllerRemove403, WorkflowTemplateStepsControllerRemove404 } from "../../models/workflowsController/WorkflowTemplateStepsControllerRemove";

function getWorkflowTemplateStepsControllerRemoveUrl(id: WorkflowTemplateStepsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/workflow-template-steps/${id}` as const }  
  return res
}

/**
 * @summary Delete a workflow template step
 * {@link /api/v1/workflow-template-steps/:id}
 */
export async function workflowTemplateStepsControllerRemove(id: WorkflowTemplateStepsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<WorkflowTemplateStepsControllerRemoveMutationResponse, ResponseErrorConfig<WorkflowTemplateStepsControllerRemove401 | WorkflowTemplateStepsControllerRemove403 | WorkflowTemplateStepsControllerRemove404>, unknown>({ method : "DELETE", url : getWorkflowTemplateStepsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}